import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from "react-redux";
import {compose} from "recompose";
import {RESOURCES as systemResources} from '../fuseSystemsResourceMap';
import {commonStyles} from '../shared/styles';
import CircularProgress from 'material-ui/CircularProgress';
import VirtualizedSelect from 'react-virtualized-select';

const styles = {
    select: {width: '100%', fontSize: 18}
};

/**
 * A component for generating rows of ChooseSystemTableRows.
 *
 */
class ChooseSystemTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayLoader: false,
            role: 'sys_user',
            systemList: [],
            systemsAll: false
        };
        this.handleChooseSystem = this.handleChooseSystem.bind(this);
    }

    componentWillMount() {
        const role = this.getRole();
        const systemList = this.formatSystemList(this.props.systemList);
        this.setState({
            role: role,
            systemList: systemList,
            systemsAll: this.props.systemsAll,
        });
        if (this.props.systemsAll === true) {
            this.setState({
                displayLoader: true,
            }, () => {
                this.fetchSystems();
            });
        } else if (systemList.length === 1) {
            const system = (systemList[0].display_name) ? systemList[0].display_name : systemList[0];
            this.props.onChooseSystem(system, this.props.user);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.systemList !== this.props.systemList ||
            nextProps.systemsAll !== this.props.systemsAll
        ) {
            this.setState({
                displayLoader: true,
                systemList: nextProps.systemList,
                systemsAll: this.props.systemsAll,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.systemList !== this.props.systemList ||
            prevProps.systemsAll !== this.props.systemsAll
        ) {
            this.setState({
                systemList: prevProps.systemList,
                systemsAll: prevProps.systemsAll
            });
        }
    }

    getRole = () => {
        let role = 'sys_user';
        const user = this.props.user;
        if (user) {
            if (user.sys_admin) {
                return 'sys_admin';
            }
            if (user.sys_op) {
                return 'sys_op';
            }
        }
        return role;
    };

    /**
     * Convert array of System names to array of objects
     *
     * @param list
     * @return {*}
     */
    formatSystemList = (list) => {
        let systemList = [];
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                const listItem = {name: null, display_name: null};
                if (list[i].name) {
                    // All Systems list is an array of objects with attributes:
                    listItem.display_name = list[i].display_name;
                    listItem.name = list[i].name;
                } else {
                    // User "system" field is an array of strings:
                    listItem.display_name = list[i];
                    listItem.name = list[i];
                }
                systemList.push(listItem);
            }
            return systemList;
        }
        return list;
    };

    /**
     * Get list of Systems if list is not provided
     */
    fetchSystems() {
        const params = {
            filter: {},
            pagination: {page: 1, perPage: 10000},
            sort: {field: 'name', order: 'ASC'}
        };

        let resource;
        if (this.state.role === 'sys_op') {
            resource = systemResources.SystemsOp.GET_LIST(params);
        } else {
            resource = systemResources.SystemsReport.GET_LIST(params);
        }

        // Retrieve the data and assign results to the Select choices
        import('../shared/serverFunctions')
            .then(functions => {
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        let filteredList = this.filterSystemsList(result.data.payload);
                        let systemList = this.formatSystemList(filteredList);
                        this.setState({
                            displayLoader: false,
                            systemList: systemList
                        });
                    }
                }).catch((error) => {
                    let message = '';
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                        if (error.response.data.error_message) {
                            message = error.response.data.error_message;
                            console.log('Error: ' + message);
                        }
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    /**
     * Filter a list to exclude inactive items
     *
     * @param list
     * @return {Array}
     */
    filterSystemsList = (list) => {
        let systemList = [];
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                if (item && item.active === true) {
                    systemList.push(item);
                }
            }
        }
        return systemList;
    };

    // Handle event from item button
    handleChooseSystem = (key) => {
        if (key && key.name) {
            this.props.onChooseSystem(key.name, this.props.user);
        }
    };

    render() {
        return (
            <div>
                {this.state.displayLoader &&
                <div style={commonStyles.loaderContainer}>
                    <h4>Retrieving Systems...</h4>
                    <CircularProgress
                        size={24}
                        thickness={2}
                        className="loader"
                    />
                </div>
                }
                <VirtualizedSelect
                    key="select-system"
                    name="select_system"
                    label=""
                    options={this.state.systemList}
                    isLoading={this.state.displayLoader}
                    labelKey="display_name"
                    valueKey="name"
                    onChange={this.handleChooseSystem}
                    className="select-system"
                    style={styles.select}
                />
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        return {
            systemList: ownProps.systemList,
            user: ownProps.user,
        }
    }
    return {}
};
ChooseSystemTable.propTypes = {
    addField: PropTypes.bool,
    onChooseSystem: PropTypes.func,
    systemList: PropTypes.array.isRequired,
    systemsAll: PropTypes.bool,
    user: PropTypes.object,
};

ChooseSystemTable.defaultProps = {
    addField: true,
    systemList: [],
    systemsAll: false,
    user: null,
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(ChooseSystemTable);



// WEBPACK FOOTER //
// ./src/Fuse/components/ChooseSystemTable.js